import Cookie from "js-cookie";
import { CSRF_TOKEN_COOKIE_NAME, UNKNOWN_ERROR_PREFIX, SERVER_TIMEOUT, SERVER_TIMEOUT_USER_FRIENDLY } from "common/constants/Constants";
import appConfig from "utils/appConfig";
import GoogleTracking from "services/GoogleTracking";
import assign from "lodash.assign";

export function request(url, options) {
    const {
        method = "GET",
        data = {},
        contentType = "application/json",
        suppressErrorTracking = false,
        external = false
    } = options;

    const requestObject = external
        ? null
        : {
            method,
            headers: {
                Accept: "application/json",
                "Content-Type": contentType,
                "x-csrf-token": Cookie.get(CSRF_TOKEN_COOKIE_NAME)
            },
            credentials: "include"
        };

    if (!contentType) {
        delete requestObject.headers["Content-Type"];
    }

    if (method !== "GET") {
        requestObject.body = contentType === "application/json"
            ? JSON.stringify(data)
            : data;
    }

    const fetchableUrl = external
        ? url
        : `${ appConfig().registrationServiceUrl }${ url }`;

    return fetch(fetchableUrl, requestObject)
        .then((response) => {
            const { status } = response;

            if (status === 204) {
                return;
            }

            if (status >= 200 && status < 300) {
                return response.json();
            }

            return response.json().then(({ type, errorMessage, errors = [] }) => {
                const errorMessageToLog = errorMessage || `${ UNKNOWN_ERROR_PREFIX } when fetching resource ${ url }`;

                console.log(errorMessageToLog);

                if (errorMessage && !suppressErrorTracking) {
                    GoogleTracking.registerErrorEvent(errorMessage);
                }

                if (!errorMessage) {
                    // make the errorMessage user friendly
                    errorMessage = `${ UNKNOWN_ERROR_PREFIX } when fetching resource. Please try again later.`;
                }

                throw {
                    status,
                    type,
                    errorMessage,
                    errors
                };
            });
        }, (error) => {
            if (console) {
                console.error(error);
            }

            const timeoutMessage = error.message === "Failed to fetch" || error.message === "Network request failed" ? SERVER_TIMEOUT : "";
            const errorMessage = timeoutMessage ? SERVER_TIMEOUT_USER_FRIENDLY : `${ UNKNOWN_ERROR_PREFIX } when trying to fetch resource. Please try again later.`;
            const googleTrackingError = errorMessage.indexOf(UNKNOWN_ERROR_PREFIX) >= 0 ? `${ errorMessage } ${ url }` : errorMessage;

            GoogleTracking.registerErrorEvent(timeoutMessage || googleTrackingError);

            throw {
                errorMessage
            };
        });
}

const Client = {
    get(url, options = {}) {
        return request(url, assign(options, {
            method: "GET"
        }));
    },
    post(url, data, options = {}) {
        return request(url, assign(options, {
            method: "POST",
            data
        }));
    },
    put(url, data, options = {}) {
        return request(url, assign(options, {
            method: "PUT",
            data
        }));
    },
    delete(url, options = {}) {
        return request(url, assign(options, {
            method: "DELETE"
        }));
    }
};

export default Client;
